import cartService from './cart.service'
import cartComponent from './cart.component'

const module = angular.module('mpa.components.cart', [])

module.service('cartService', cartService).component('cart', cartComponent)

export default module.name
